// extracted by mini-css-extract-plugin
module.exports = {"form":"search-form-module--form--10rPi","button":"search-form-module--button--1kPR5"};